import { render, staticRenderFns } from "./ReviewsCategoriesTableActionColumn.vue?vue&type=template&id=486f9cae&scoped=true&"
import script from "./ReviewsCategoriesTableActionColumn.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategoriesTableActionColumn.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCategoriesTableActionColumn.vue?vue&type=style&index=0&id=486f9cae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486f9cae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VMenu})
